import { useEffect } from "react";

import { useRootStore } from "store";
import BannerMessage from "../components/BannerMessage";
import EditUser from "../components/EditUser";
import SystemMessage from "../components/SystemMessage";
import { UserForm } from "models/admin/admin";

import "./Admin.scss";

export default function Admin() {
  const { user } = useRootStore((state) => state);

  const { editUser, editExternalUser } = useRootStore((state) => state.admin);
  const { isSaving } = editUser;

  const {
    sendSystemMessage,
    sendSystemMessageExternal,
    deleteNotification,
    fetchNotifications,
    fetchSysMessage
  } = useRootStore((state) => state.notifications);

  const { notifications } = useRootStore((state) => state);

  useEffect(() => {
    fetchNotifications();
    fetchSysMessage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleItemConfirm = (request: UserForm) => {
    editExternalUser(request);
  };

  const handleSubmit = (message: string, hours: string) => {
    sendSystemMessage(message, hours);
  };

  const handleSubmitExternal = (message: string, hours: string) => {
    const sysMessage = {
      message: message,
      hours: hours
    };
    sendSystemMessageExternal(sysMessage);
  };

  const deleteSystemMessage = (messageId: string) => {
    deleteNotification(messageId);
  };

  return (
    <div className="adminWrapper">
      <div className="box-banner">
        <div className="box">
          <h1>Redigera användare</h1>
          <EditUser isSaving={isSaving} handleItemConfirm={handleItemConfirm} />
        </div>

        <div className="box">
          <h1>Hantera banners</h1>
          <BannerMessage />
        </div>
      </div>

      <div className="box-banner">
        <div className="box">
          <h1>Systemmeddelande</h1>
          <SystemMessage
            internalMessages={notifications.messages}
            staticSysMessage={user.sysMessage}
            deleteSystemMessage={deleteSystemMessage}
            deleteExternalSystemMessage={() => handleSubmitExternal("", "0")}
            handleSubmit={handleSubmit}
            handleSubmitExternal={handleSubmitExternal}
          />
        </div>
      </div>
    </div>
  );
}
